import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "../styles/addEditLearnMoreScreen.module.css";
import LearnMoreChunk from "../components/LearnMoreChunk";
import FBLearnmoreBuilder from "../models/builders/FBLearnmoreBuilder";

const AddEditLearnMoreScreen = ({
  selectedSubright,
  editLearnMore,
  addLearnMore,
  deleteLearnMore,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const learnMore = location.state.learnMore;
  const editMode = location.state.editMode;
  const changedInfoChunksIdxs = new Set();


  const [title, setTitle] = useState(learnMore != null ? learnMore.title : "");
  const [informationChunks, setInformationChunks] = useState(
    learnMore != null ? learnMore.informationChunks : []
    );
    const [infoChunksChanged, setInfoChunksChanged] = useState(false);
    const [titleChanged, setTitleChanged] = useState(false);

  const renderLearnMoreChunks = () => {
    const res = informationChunks.map((infoChunk, index) => {
      return (
        <LearnMoreChunk
          key={'learnMoreChunk' + index}
          infoChunk={infoChunk}
          index={index}
          onChangeHeader={onChangeHeader}
          onChangeBody={onChangeBody}
          onRemoveLearnMoreChunk={onRemoveLearnMoreChunk}
        />
      );
    });

    return res;
  };

  const checkChangedInfoChunks = (header, body, index) => {
    if (index >= learnMore.informationChunks.length) {
      changedInfoChunksIdxs.add(index);
      return true;
    }

    const oldInfoChunk = learnMore.informationChunks[index];
    if (header !== oldInfoChunk.header || body !== oldInfoChunk.body) {
      changedInfoChunksIdxs.add(index);
      return true;
    } else {
      changedInfoChunksIdxs.delete(index);
    }

    if (changedInfoChunksIdxs.size > 0) {
      return true;
    }

    return false;
  };

  const onRemoveLearnMoreChunk = (index) => {
    const infoChunks = [...informationChunks];
    infoChunks.splice(index, 1);
    setInformationChunks(infoChunks);
    if (editMode) {
      // * clears the index set for rebuilding
      changedInfoChunksIdxs.clear();
      if (infoChunks.length > 0) {
        infoChunks.forEach((infoChunk, index) => {
          changedInfoChunksIdxs.add(index);

          // if (index >= learnMore.informationChunks.length) {
          //   changedInfoChunksIdxs.add(index);
          // } else {
          //   const tempChunk = learnMore.informationChunks[index];
          //   if (
          //     tempChunk.header !== infoChunk.header ||
          //     tempChunk.body !== infoChunk.body
          //   ) {
          //     changedInfoChunksIdxs.add(index);
          //   }
          // }
        });
      } else {
        learnMore.informationChunks.forEach((learnMoreInfoChunk, index) => {
          changedInfoChunksIdxs.add(index);
        });
      }
      setInfoChunksChanged(true);
    }
  };

  const onChangeHeader = (index, newHeader) => {
    const changedInfoChunks = [...informationChunks];
    const chunkToChange = changedInfoChunks[index];
    const changedChunk = {
      ...chunkToChange,
      header: newHeader,
    };
    changedInfoChunks[index] = changedChunk;
    setInformationChunks(changedInfoChunks);
    if (editMode) {
      setInfoChunksChanged(
        checkChangedInfoChunks(changedChunk.header, changedChunk.body, index)
      );
    }
  };

  const onChangeBody = (index, newBody) => {
    const changedInfoChunks = [...informationChunks];
    const chunkToChange = changedInfoChunks[index];
    const changedChunk = {
      ...chunkToChange,
      body: newBody,
    };
    changedInfoChunks[index] = changedChunk;
    setInformationChunks(changedInfoChunks);
    if (editMode) {
      setInfoChunksChanged(
        checkChangedInfoChunks(changedChunk.header, changedChunk.body, index)
      );
    }
  };

  const onChangeTitleText = (e) => {
    const enteredTitle = e.target.value;
    if (editMode) {
      setTitleChanged(enteredTitle !== learnMore.title);
    }
    setTitle(e.target.value);
  };

  const onClickAddNewParagraph = () => {
    changedInfoChunksIdxs.add(informationChunks.length);
    setInformationChunks([...informationChunks, { header: "", body: "" }]);
    setInfoChunksChanged(changedInfoChunksIdxs.size > 0);
  };

//  * moves the user to the previous selection upon cancel
  const onClickCancel = () => {
    navigate(-1);
  };

  // * checks if any of the headers and body are empty and returns a boolean (I think headers can be optional TT)
  const checkInformationChunksValidity = () => {
    let validInput = true;
    informationChunks.forEach((infoChunk) => {
      if (infoChunk.body === "") {
      // if (infoChunk.header === "" || infoChunk.body === "") {

        validInput = false;
        return;
      }
    });
    return validInput;
  };

  // * checks if any of the bodies are empty and returns a boolean
  const checkIfChunksAreEmpty = () => {
    let emptyCheck = false;
    if (informationChunks.length === 0) {
      return true;
    }
    informationChunks.forEach((infoChunk) => {
      if (infoChunk.body === "") {
        emptyCheck = true;
        return;
      }
    });
    return emptyCheck;
  };

  const isValidInput = () => {
    if (title === "" || checkIfChunksAreEmpty()) {
      // TODO make an alert modal or toast here
      return false;
    }
    return true;
  };

  const onClickSave = () => {
    if (!isValidInput() || !checkInformationChunksValidity()) {
      // TODO: Display an error
      return;
    }
    if (editMode) {
      const newLearnMore = FBLearnmoreBuilder.buildFBLearnmore(
        title,
        informationChunks,
        selectedSubright.id
      );
      editLearnMore(newLearnMore, learnMore, () => {
        navigate(-1);
      });
    } else {
      const newLearnMore = FBLearnmoreBuilder.buildFBLearnmore(
        title,
        informationChunks,
        selectedSubright.id
      );
      addLearnMore(newLearnMore, () => {
        navigate(-1);
      });
    }
  };

  const onClickDelete = () => {
    if (window.confirm("Are you sure you want to delete this learn more?")) {
      deleteLearnMore(learnMore, selectedSubright, () => {
        navigate(-1);
      });
    }
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.innerContainer}>
        <p className={styles.title}>Right Category Information</p>
        <div className={styles.formContainer}>
          <div className={styles.fieldContainer}>
            <p className={styles.fieldLabel}>Title:</p>
            <input
              className={styles.inputStyle}
              type="text"
              value={title}
              onChange={onChangeTitleText}
              placeholder="Please write a title for this category here (required)..."
            />
          </div>
          <div className={styles.fieldContainer}>
            <p className={styles.fieldLabel}>Info:</p>
            <div className={styles.infoChunksContainer}>
              {renderLearnMoreChunks()}
            </div>
          </div>
          <div
            className={styles.newParagraphButton}
            onClick={onClickAddNewParagraph}
          >
            Add New Info Block
          </div>
          <div className={styles.buttonsContainer}>
            <div className={styles.cancelButton} onClick={onClickCancel}>
              Cancel
            </div>
            {editMode ? (
              <div className={styles.deleteButton} onClick={onClickDelete}>
                Delete
              </div>
            ) : null}
            {infoChunksChanged || titleChanged || !editMode ? (
              <div className={styles.saveButton} onClick={onClickSave}>
                Save
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEditLearnMoreScreen;
